import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";

import { User as UService } from "src/services/User Management";
import { User as UAdapter } from "src/adapters/User Management";

import { select as select_profiles } from "./profile";

const service = new UService();
const adapter = new UAdapter();

const REDUCER_MODULE_NAME = "USER";

const initialState = {
  grid: {
    activos: {
      page: 1,
      skip: 0,
      take: 3,
      rows: 0,
      data: [],
      show: 3,
    },
    inactivos: {
      page: 1,
      skip: 0,
      take: 3,
      rows: 0,
      data: [],
      show: 3,
    },
  },
  loading: false,
  formIsReady: false,
  data: "",
  message: "",
  error: "",
};

export const grid_activos = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/grid_activos`,
  async ({ skip, take, currentPage = 1 }) => {
    const { data } = await service.grid(skip, take, 1);

    return {
      skip,
      take,
      grid_data: data,
      page: currentPage,
    };
  },
);

export const grid_inactivos = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/grid_inactivos`,
  async ({ skip, take, currentPage = 1 }) => {
    const { data } = await service.grid(skip, take, 0);

    return {
      skip,
      take,
      grid_data: data,
      page: currentPage,
    };
  },
);

export const getById = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/getById`,
  async (id) => {
    const { data } = await service.getById(id);

    return {
      entity: data,
    };
  },
);

export const changeActive = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/changeActive`,
  async ({ id }, { dispatch, getState }) => {
    await service.changeActive(id);

    const { user } = getState();

    dispatch(
      grid_activos({
        skip: user.grid.activos.skip,
        take: user.grid.activos.take,
        currentPage: user.grid.activos.page,
      }),
    );
    dispatch(
      grid_inactivos({
        skip: user.grid.inactivos.skip,
        take: user.grid.inactivos.take,
        currentPage: user.grid.inactivos.page,
      }),
    );
  },
);

export const form = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/form`,
  async (id, { dispatch }) => {
    dispatch(select_profiles());

    if (id) {
      dispatch(getById(id));
    }
  },
);

export const submit = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/submit`,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      if (id) {
        await service.update(id, data);
      } else {
        await service.create(data);
      }

      return {
        message: `Usuario ${id ? "modificado" : "creado"} correctamente.`,
      };
    } catch (error) {
      return rejectWithValue(error.errors || error.message);
    }
  },
);

export const userSlice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    clean: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(grid_activos.fulfilled, (state, action) => {
        const { page, skip, take, grid_data } = action.payload;
        state.grid.activos = {
          ...state.grid.activos,
          page,
          skip,
          take,
          rows: grid_data.rows,
          data: adapter.from_api_to_grid(grid_data.data),
        };
      })
      .addCase(grid_inactivos.fulfilled, (state, action) => {
        const { page, skip, take, grid_data } = action.payload;
        state.grid.inactivos = {
          ...state.grid.inactivos,
          page,
          skip,
          take,
          rows: grid_data.rows,
          data: adapter.from_api_to_grid(grid_data.data),
        };
      })
      .addCase(getById.fulfilled, (state, action) => {
        state.data = action.payload.entity || "";
      })
      .addCase(submit.fulfilled, (state, action) => {
        state.message = action.payload.message;
        state.formIsReady = true;
      })

      // Global Matchers
      .addMatcher(
        isAnyOf(
          grid_activos.pending,
          grid_inactivos.pending,
          changeActive.pending,
          getById.pending,
          form.pending,
          submit.pending,
        ),
        (state) => {
          state.loading = true;
          state.error = "";
          state.formIsReady = false;
        },
      )
      .addMatcher(
        isAnyOf(
          grid_activos.fulfilled,
          grid_inactivos.fulfilled,
          changeActive.fulfilled,
          getById.fulfilled,
          form.fulfilled,
          submit.fulfilled,
        ),
        (state) => {
          state.loading = false;
        },
      )
      .addMatcher(
        isAnyOf(
          grid_activos.rejected,
          grid_inactivos.rejected,
          changeActive.rejected,
          getById.rejected,
          submit.rejected,
        ),
        (state, action) => {
          state.loading = false;
          state.error = action.payload || "Error desconocido";
        },
      );
  },
});

export const { clean } = userSlice.actions;

export default userSlice.reducer;
